import { LoadStatus, type LocalFile, type MimeTypeValues } from 'common/constants/files';
import generateFileID from 'common/file/utils/generateFileID';
import getExtensionFromContentType from 'common/file/utils/getExtensionFromContentType';
import getFileNameWithoutExtension from 'common/file/utils/getFileNameWithoutExtension';

export const parseToLocalFile = (file: File): LocalFile => {
  return {
    extension: getExtensionFromContentType(file.type),
    name: getFileNameWithoutExtension(file.name),
    uniqueID: generateFileID(),
    contentType: file.type as MimeTypeValues,
    uploadStatus: LoadStatus.notStarted,
    url: null,
  };
};
